<template>

<v-dialog v-model="dialog" width="1250px">
  <v-card>
    <v-card-title class="text-h5 grey lighten-2">
                              View Photo Assignment {{hsfo.huis_code }}
                            </v-card-title>
    <v-card-text>
    
                            <v-form ref="viewHsfo" v-model="viewHsfoValid">
      <v-row no-gutters>
        
      </v-row>  
      
      <v-row>  
          <v-col cols="6">
              <v-select label="Status" v-model="hsfo.hsfo_status" :items="hsfo.hsfo_statusKeuzes" item-text="oms" item-value="value">
                  <template v-slot:item="data">
                      <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
                  <template v-slot:selection="data">
                      <v-chip :color='statuscolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
              </v-select>
          </v-col>
          <v-col cols="6">
              <v-select label="Priority" v-model="hsfo.hsfo_prio" :items="hsfo.hsfo_prioKeuzes" item-text="oms" item-value="value">
                  <template v-slot:item="data">
                      <v-chip :color='priocolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
                  <template v-slot:selection="data">
                      <v-chip :color='priocolor[data.item.value]'>{{ data.item.oms }}</v-chip>
                  </template>
              </v-select>
          </v-col>
      </v-row>
      
      
      
      <v-row>
        <v-col cols="6">
          <v-select label="Contact" v-model="hsfo.hsfo_contact" :items="hsfo.contact_choices" item-text="eign_naam" item-value="eign_code">
              </v-select>
        </v-col>  
        <v-col cols="6">
          <v-select label="Photographer" v-model="hsfo.hsfo_fotograaf" :items="hsfo.photographer_choices" item-text="gebr_naam" item-value="gebr_code">
              </v-select>
        </v-col>  
      </v-row>  
      <v-row>
        <v-col cols="6">
          <v-menu v-model="hsfo.hsfo_deadlineMenu" :close-on-content-click="false"
          :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
          <template v-slot:activator="{ on }">
              <v-text-field v-model="hsfo.hsfo_deadline" label="Deadline"
              v-on="on" dense></v-text-field>
          </template>
          <v-date-picker v-model="hsfo.hsfo_deadline2" :first-day-of-week="1"
              @input="hsfo.hsfo_deadline = $moment(hsfo.hsfo_deadline2).format('DD-MM-YYYY');"></v-date-picker>
          </v-menu>
        </v-col>  

        <v-col cols="6">
          <v-text-field
              prefix="€"
              v-model="hsfo.hsfo_vergoeding"
              type="number"
              label="Vergoeding"
              dense
            ></v-text-field>
        </v-col>
      </v-row>  

      <v-row>
        <v-col cols="12">
          <v-select label="Tasks" v-model="hsfo.hfot_types" :items="hsfo.hfot_typeKeuzes" item-text="oms" item-value="value" chips multiple>
              </v-select>
        </v-col>
      </v-row>

      <v-row>

        <v-col v-for="(hfot, hfotidx) in hsfo.hfot" :key="hfotidx">
            <v-card>
            <v-card-title>{{ hfot.hfot_type }}</v-card-title>
            <v-container>
            
            
            <v-row>
                <v-col cols="12">
                <v-select v-model="hfot.hfot_status" :items="hsfo.hfot_statusKeuzes" item-text="oms" item-value="value" >
                    <template v-slot:item="data">
                    <v-chip :color='statuscolor_hfot[data.item.value]'>{{ data.item.oms }}</v-chip>
                    </template>
                    <template v-slot:selection="data">
                    <v-chip :color='statuscolor_hfot[data.item.value]'>{{ data.item.oms }}</v-chip>
                    </template>
                    <template v-slot:append-outer>
                    <v-btn color="secundary" @click="updHfot(hfot.hfot_encrid,hfot.hfot_status,hfot.hfot_deadline,hfot.hfot_oms)">Update</v-btn>
                    </template>
                </v-select>

                <!-- <v-chip :color='statuscolor_hfot[hfot.hfot_status]'>{{ hfot.hfot_status }}</v-chip> -->
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-menu v-model="hfot.hfot_deadlineMenu" :close-on-content-click="false"
                    :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="hfot.hfot_deadline" label="Deadline"
                        v-on="on" dense></v-text-field>
                    </template>
                    <v-date-picker v-model="hfot.hfot_deadline2" :first-day-of-week="1"
                        @input="hfot.hfot_deadline = $moment(hfot.hfot_deadline2).format('DD-MM-YYYY');"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                <v-textarea
              v-model="hfot.hfot_oms"
              label="Description"
              hint="Short description"
              rows="3"
            ></v-textarea>   
                </v-col>
            </v-row>
            </v-container>
            </v-card>

        </v-col>
        
        </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
              v-model="hsfo.hsfo_description"
              label="Description"
              hint="Short description of the photo assignment"
              rows="3"
            ></v-textarea>
        </v-col>  
      </v-row>  

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="updHsfo" :disabled="!viewHsfoValid" :loading="uploading">Save</v-btn>
      <v-btn color="primary" small @click="dialog = false" :disabled="uploading">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      hsfo: { huis_code: '' },
      dialog: false,
      viewHsfoValid: false,
      uploading: false,
      huis_encrid: null,
      hsfo_description: null,
      hsfo_deadline: null,
      hsfo_fotograaf: null,
      hsfo_vergoeding: null,
      hsfo_contact: null,
      hsfo_status: null,
      hsfo_prio: null,
      hsfo_hfot: [],
      fttg_nrKeuzes: [],
      hsft_foto: null,
      hsft: {},
      url: null,
      image:{
        size:'',
        height:'',
        width:'',
        src: null
      },
      fttg_nrRules: [
          v => !!v || "A Tag is required"
      ],
      hsft_fotoRules: [
          v => !!v || "A photo is required"
      ],
      priocolor: {
        Low: '#D1E2FF',
        Medium: '#74EBE1',
        High: '#DC043B'
      },
      statuscolor: {
        Signedup: '#FAD2FC',
        Readytoshoot: '#FFEAB6',
        Offered: '#D1E2FF',
        Assigned: '#88DBFF',
        Completed: '#9AE095',
        Rejected: '#41454D',
        Onhold: '#FFB68E'
      },
      statuscolor_hfot: {
        Notapplicable: '#DC043B',
        Pending: '#D1E2FF',
        Completed: '#9AE095'
      }
    }
  },
  mounted() {   /* Work around voor Safari */
     let inputs = document.querySelectorAll('.v-file-input input');
         [...inputs].forEach((input) => {
              input.remove()
          })
  },
  methods: {
    open(hsfo_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hsfo_encrid = hsfo_encrid;
      this.url = null;
      this.hsft_foto = null;
      this.$axios
        .post("ares/json/ares/huis/hsfo/getHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsfo"
          },
          getHsfo: {
            hsfo_encrid: hsfo_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsfo = res.data.getHsfo;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updHfot(hfot_encrid,hfot_status,hfot_deadline,hfot_oms) {
      this.$axios
        .post("ares/json/ares/huis/hsfo/updHfot.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHfot"
          },
          updHfot: {
            hsfo_encrid: this.hsfo_encrid,
            hfot_encrid: hfot_encrid,
            hfot_status: hfot_status,
            hfot_deadline: hfot_deadline,
            hfot_oms: hfot_oms
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHfot.text,
              color: res.data.updHfot.color
            });
          }
        })
    },
    updHsfo() {
      this.$axios
        .post("ares/json/ares/huis/hsfo/updHsfo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updHsfo"
          },
          updHsfo: {
            hsfo_encrid: this.hsfo_encrid,
            hsfo_status: this.hsfo.hsfo_status,
            hsfo: this.hsfo,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updHsfo.text,
              color: res.data.updHsfo.color
            });
            this.hsfo.hfot = res.data.updHsfo.hfot;
          }
        })
    }
  }
}
</script>

